import fetch from "auth/FetchInterceptor";

const TicketService = {};

TicketService.getTickets = function (params = {}) {
  let url = "/tickets/";
  const queryParams = [];

  if (params.status) queryParams.push(`status=${params.status}`);
  if (params.priority) queryParams.push(`priority=${params.priority}`);
  if (params.category) queryParams.push(`category=${params.category}`);
  if (params.search) queryParams.push(`search=${encodeURIComponent(params.search)}`);

  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  return fetch({ url, method: "get" });
};

TicketService.getTicket = function (ticketId) {
  return fetch({
    url: `/tickets/${ticketId}/`,
    method: "get",
  });
};

TicketService.createTicket = function (data) {
  return fetch({
    url: "/tickets/",
    method: "post",
    data,
  });
};

TicketService.updateTicket = function (ticketId, data) {
  return fetch({
    url: `/tickets/${ticketId}/`,
    method: "put",
    data,
  });
};

TicketService.deleteTicket = function (ticketId) {
  return fetch({
    url: `/tickets/${ticketId}/`,
    method: "delete",
  });
};

TicketService.replyToTicket = function (ticketId, data) {
  return fetch({
    url: `/tickets/${ticketId}/reply/`,
    method: "post",
    data,
  });
};

export default TicketService;
